/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "522")




export interface API54769Req {
  
  /** 任务id */
  taskId?: string;
    
};



export interface API54769Res {
  /** 是否可以反馈  */
  feedBack?: boolean;
  /** 创建权限  */
  create?: boolean;
  /** 关联OKR权限  */
  relateOkr?: boolean;
  /** 是否可查看  */
  read?: boolean;
  /** 是否可编辑  */
  edit?: boolean;
  /** 是否可删除  */
  delete?: boolean;
  /** 是否可下载  */
  download?: boolean;
  
};


// 54769 任务权限接口

export interface IUseGetAPI54769Return {
  /** 任务权限接口: 接口请求状态 */
  isAPI54769Loading: boolean;
  /** 任务权限接口: 接口请求返回数据 */
  dataAPI54769: API54769Res;
  /**  任务权限接口: 接口数据请求方法 */
  fetchAPI54769Data:  (inputs: API54769Req, config?: YWRequestConfig) => Promise<API54769Res>;
  /** 任务权限接口: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI54769 = ():IUseGetAPI54769Return => {
  let isMount = true;
  const [isAPI54769Loading, setIsAPI54769Loading] = useState(false);
  const [dataAPI54769, setDataAPI54769] = useState<API54769Res>({} as API54769Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/task/auth`;

  const fetchAPI54769Data = async (inputs: API54769Req, config?: YWRequestConfig): Promise<API54769Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API54769Req>) || {}) as API54769Req;
    
  
    if ( isMount ) {
      setIsAPI54769Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API54769Res>(`${basePath}/corp-admin/project/plan/task/auth?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI54769(res || {} as API54769Res);
        setIsAPI54769Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI54769Loading(false);
      }
      return false as unknown as API54769Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI54769Loading,
    dataAPI54769,
    fetchAPI54769Data,
    requestUrl,
  }
}

